import { render } from "./PromotionComponent.vue?vue&type=template&id=144301b5"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"

import "./PromotionComponent.vue?vue&type=style&index=0&id=144301b5&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__